import { forwardRef } from "react";
import { Input, type InputProps } from "@/components/ui/input";
import { formatUsPhone } from "@/lib/format";

export interface PhoneFieldProps
  extends Omit<InputProps, "value" | "onChange" | "type" | "inputMode" | "autoComplete"> {
  value: string;
  onChange: (value: string) => void;
}

export const PhoneField = forwardRef<HTMLInputElement, PhoneFieldProps>(
  ({ value, onChange, placeholder = "(234) 546-9889", clearable = true, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        placeholder={placeholder}
        maxLength={14}
        value={value}
        onChange={(e) => onChange(formatUsPhone(e.target.value))}
        clearable={clearable}
        onClear={() => onChange("")}
        {...props}
      />
    );
  },
);
PhoneField.displayName = "PhoneField";
